import React from 'react'
import classes from './styles.module.scss'

interface BadgeProps {
  children: React.ReactNode
}

export const Badge: React.FC<BadgeProps> = (props) => {
  const { children } = props

  if (!children) return null

  return (
    <div className={classes.badge}>
      {children}
    </div>
  )
}
